module.exports = __webpack_public_path__ + "media/src/images/drag_light-230816297d3bab3b1b02d5a78ad73b16.png";